import React, { Component } from 'react';
import classNames from 'classnames';
import { Repeater, ItemContainer } from '../../../../library/repeater';
import { Switch, Case, Default } from '../../../../library/ReactSwitchCase';
import DateUtil from '../../../../library/util/DateUtil';
import EventListItem from './EventListItem';
import PostListInjector from '../../../../library/board/PostListInjector';

class EventListContainer extends Component {
  constructor(props) {
    super(props);

    this.onClickItem = this.onClickItem.bind(this);
  }

  //이미지 클릭 시 상세페이지 이동
  onClickItem(e, postId) {
    e.preventDefault();
    this.props.goPostDetail(postId);
  }

  componentDidMount() {
    const params = {
      data__event_info__end_date__gte: DateUtil.today(),
      status__ne: 2,
    };
    this.props.loadPostList(params);
  }

  render() {
    const { postList } = this.props;
    return (
      <div>
        <h4 className={classNames({ 'line no-margin': postList.count > 0 })}>
          이벤트
        </h4>
        <Switch condition={postList.count > 0}>
          <Case value={true}>
            <section className="event-big-list">
              <Repeater
                arrayData={postList.results}
                propName="postInfo"
                elementName="ul"
              >
                <ItemContainer>
                  <EventListItem
                    {...this.props}
                    onClickItem={this.onClickItem}
                  />
                </ItemContainer>
              </Repeater>
            </section>
          </Case>
          <Default>
            <div className="message-box no-data no-line">
              <p>
                <strong>진행 중인 이벤트가 없습니다.</strong>
                앞으로 진행될 이벤트를 기대해 주세요!
              </p>
            </div>
          </Default>
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initLoad: false,
    history: ownProps.history,
  };
};

export default PostListInjector(mapStateToProps)(EventListContainer);
